import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import uamRequestsTimeouts from '../consts/uam/uamRequestsTimeouts';
import firmwareUpdateAutomaticInstallationService from '../containers/DeviceSettingsPage/FirmwareUpdate/services/firmwareUpdateAutomaticInstallationService';
import damAsyncRequestService from '../services/dam/damAsyncRequestService';
import damDeviceHelpers from '../services/dam/damDeviceHelpers';
import damDeviceService from '../services/dam/damDeviceService';
import log from '../services/logger/log';
import {selectDeviceFirmware} from '../state/selectors/iotDevices';
import {updateDeviceFirmwareData} from '../state/slice/iotDevices';
import {dispatch} from '../state/store';

const useDeviceFirmwareUpdate = (dusn) => {
    const {requestId, isManual} = useSelector(selectDeviceFirmware(dusn)) || {};
    const isFirmwareUpdateInProgress = damDeviceHelpers.checkIsFirmwareUpdateInProgress(dusn);

    const subscribeFirmwareUpdateProgress = async () => {
        log.info(`useDeviceFirmwareUpdate: Subscribed to firmware update, dusn: ${dusn}, requestId: ${requestId}`);

        try {
            const promises = [
                damAsyncRequestService.waitAsyncRequestComplete(dusn, requestId, uamRequestsTimeouts.FIRMWARE),
            ];

            // If it's a manual update, we've checked it before starting the FWU on the FWU Check page
            if (!isManual) {
                promises.push(firmwareUpdateAutomaticInstallationService.getAutomaticInstallationConfig(dusn));
                promises.push(damDeviceService.getFirmwareUpdateAvailability(dusn));
            }

            await Promise.all(promises);

            damDeviceService.firmwareUpdateSuccessHandler(dusn, requestId);

            log.info(`useDeviceFirmwareUpdate: Firmware update completed, dusn: ${dusn}, requestId: ${requestId}`);
        } catch (e) {
            log.error(`useDeviceFirmwareUpdate: Firmware update failed, dusn: ${dusn}, requestId: ${requestId}`);

            damDeviceService.firmwareUpdateErrorHandler(dusn, requestId, e);
        } finally {
            dispatch(updateDeviceFirmwareData(dusn, {isManual: false}));
        }
    };

    useEffect(() => {
        if (isFirmwareUpdateInProgress) {
            subscribeFirmwareUpdateProgress();
        }
    }, [isFirmwareUpdateInProgress]);
};

export default useDeviceFirmwareUpdate;
